<!-- Check if device is in portrait mode and display warning -->
<script context="module" lang="ts">
	// Alex's Awesome Debugger
  import { isFirefox } from './stores.ts'; 			/* Load Global Data */

  /* Svelte Portrait Detection */
  import Viewport from 'svelte-viewport-info'
  let i_size	= '48px';		                      /* Icons Size */
</script>

<div class="only-portrait {$isFirefox ? 'glass_fallback' : 'glass'} shadow">
  <svg width="{i_size}" height="{i_size}" class="logo">
    <image xlink:href="icons/icon-rotate.svg" src="icons/icon-rotate.png" width="{i_size}" height="{i_size}" />
  </svg>
  <p>
    <strong>Please Rotate Device</strong><br />
    Landscape Only Experience
  </p>
</div>

<style>
	/* PORTRAIT MODE */
	:global(.Landscape .only-portrait) {
		display: none;
	}
	:global(.Portrait .only-landscape) {
		display: none;
	}
	:global(.Portrait .only-portrait) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    width:100%; height: 100%;
    vertical-align: middle;
    text-align: center;
    font-size: large;

    z-index: 4001;
    position: absolute;
    top: 0; left: 0;
		/* padding: 2rem; */
		/* padding-top:40vh; */
		/* height:100vh; */
    color: #000;
    background: rgb(255,193,7,1);
    /* background: radial-gradient(circle, rgba(255,193,7,1) 65%, rgba(222,166,0,1) 100%); */
    /* background: rgb(251,170,0);
    background: linear-gradient(135deg, rgba(251,170,0,1) 0%, rgba(241,90,36,1) 100%) */
	}
  .logo {
    filter: invert(100);
  }
</style>
